import { Zap } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useGetApiCompaniesCurrentEmployeesReportingTopemployees } from '@/api/generated/company-management-user/company-management-user'
import { StatisticsCard } from '../components/StatisticsCard'

export function TopActionsCard() {
  const { t } = useTranslation('dashboard')
  // Shares the request with TopPointsCard via the same query key
  const { data, isLoading, isError } = useGetApiCompaniesCurrentEmployeesReportingTopemployees()

  const top = data?.data?.topActions

  return (
    <StatisticsCard
      title={t('statistics.topActions.title')}
      value={top ? top.value.toLocaleString('de-DE') : '—'}
      sub={top ? [top.firstName, top.lastName].filter(Boolean).join(' ') : undefined}
      CustomIcon={Zap}
      isLoading={isLoading}
      isError={isError}
    />
  )
}
